import * as React from "react";

import "./analytics-zips.scss";
import { AnalyticsCalloutBlogComponent }     from "../../analytics-blog/analytics-blog";
import { xdQAAttribute }                     from "../../analytics-layout";
import { analyticSum, analyticSummaryArray } from "../analytics-locale";

const HEIGHT_VIEWBOX = 100
const WIDTH_VIEWBOX = 200
const KEY_ANALYTIC = 'zip'
const DISPLAY_MAX = 3

export const AnalyticsZips = ({leadInteractions, unfilteredLeadInteractions, colorsFill, settings, blogs}) => {
    const viewBox = `0 0 ${WIDTH_VIEWBOX} ${HEIGHT_VIEWBOX}`
    const [hoveredValue, setHoveredValue] = React.useState(null)
    const values = analyticSummaryArray(leadInteractions, KEY_ANALYTIC, 'idLead', KEY_ANALYTIC)
    const unfilteredValues = analyticSummaryArray(unfilteredLeadInteractions, KEY_ANALYTIC, 'idLead', KEY_ANALYTIC)
    const sum = analyticSum(values, DISPLAY_MAX)

    const blog = blogs?.find(blog => blog?.id === settings?.zipCodesBlogId)

    return (
        <div className="zipcode-graph-zyx098" >
            <div className="zipcode-legend">
                <h5
                    className="legend-title"
                    {...xdQAAttribute('label', 'zip title')}
                >
                    Zip Codes
                </h5>
                <p
                    className="legend-subtitle"
                    {...xdQAAttribute('text', 'zip subtitle')}
                >
                    {subheaderText(values)}
                </p>
            </div>
            <svg
                className="zip-codes"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                viewBox={viewBox}
                {...xdQAAttribute('image', 'zip chart')}
            >
                {
                    values.map((value, i) => {
                        return (
                            i < DISPLAY_MAX
                            ?
                                <ZipCodeBar
                                    key={i}
                                    index={i}
                                    fillColor={colorsFill[i % colorsFill.length]}
                                    value={value}
                                    sum={sum}
                                    setHoveredValue={setHoveredValue}
                                />
                            : null
                        )
                    })
                }
            </svg>
            {blog && unfilteredValues.length < (settings?.hideZipCodesBlogThreshold || 3) && (
                <div className="zipcode-blog">
                    <AnalyticsCalloutBlogComponent {...{
                        name: blog?.title,
                        urlBlog: blog?.slug,
                        callout: settings?.zipCodesBlogCallout,
                        iconName: settings?.zipCodesBlogIcon
                    }}/>
                </div>
            )}
        </div>
    )
}

const subheaderText = (values) => {
    if(!values) {
        return 'No leads found'
    }
    if(values.length === 0) {
        return 'No leads found'
    }
    if(values.length === 1) {
        return 'Zip code with the most leads'
    }

    return 'Zip codes with the most leads'
}

const ZipCodeBar = ({index, fillColor, value, sum, setHoveredValue}) => {
    const ref = React.useRef(null)
    const [isHovered, setIsHovered] = React.useState(false)

    const handlePointerEnter = () => {
        setHoveredValue(value.label)
        setIsHovered(true)
    }

    const handlePointerLeave = () => {
        setHoveredValue(null)
        setIsHovered(false)
    }

    const offsetCount = (count) => {
        const offsetBase = WIDTH_VIEWBOX - 3
        const offsetCharacter = -5
        const orderOfMagnitude = count.toString().length

        return offsetBase + orderOfMagnitude * offsetCharacter
    }

    const widthMax = WIDTH_VIEWBOX
    const fillMin = 30
    const fillMax = widthMax - 65
    const height = HEIGHT_VIEWBOX / (2 * DISPLAY_MAX)
    const y = HEIGHT_VIEWBOX / 5 * (index + 1)
    const fontSize = 9
    const offsetTextY = y + 12
    const offsetTextCount = fillMin + fillMax + 1
    const offsetTextZip = 3.5
    const translucent = "#FFFFFF00"
    const colorBackground = "#33415020"
    const colorCount = "#249AF3"

    const zipcode = value.label
    const zipCount = value.count

    return (
        <>
            <rect
                x="0"
                y={y}
                width={widthMax}
                height={height}
                rx="0"
                fill={colorBackground}
            />
            <rect
                x="0"
                y={y}
                width={fillMin + Math.floor(fillMax * value.count / sum)}
                height={height}
                rx="2"
                fill={fillColor}
            />
            <text
                x={offsetTextZip}
                y={offsetTextY}
                fill="white"
                fontSize={fontSize}
                {...xdQAAttribute('text', zipcode)}
            >
                {zipcode}
            </text>
            <text
                x={offsetCount(value.count)}
                y={offsetTextY}
                fill={colorCount}
                fontSize={fontSize}
                fontWeight="bold"
                {...xdQAAttribute('text', `count ${zipcode}`)}
            >
                {zipCount}
            </text>
            <rect
                className="bar hover"
                ref={ref}
                x="0"
                y={y}
                width={widthMax}
                height={height}
                onPointerEnter={handlePointerEnter}
                onPointerLeave={handlePointerLeave}
                rx="0"
                fill={translucent}
            />
        </>
    )
}